// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper_t34wc","small":"small_2r16b","big":"big_WcxYT"};